import richTextContentStyles from './richTextContent.styles'

const styles = {
  content: {
    ...richTextContentStyles/*,
    '& p': {
      color: '#FF8C00 !important',
    },
    '& h2': {
      color: '#d1402d !important',
    },
    '& li': {
      listStyleType: 'square !important',
    },*/
  },
}

export default styles
